import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-dashboard.dashboard-label',
		defaultMessage: 'Dashboard',
		description:
			'Badge label shown on a dashboard search result card to identify the result type as a dashboard.',
	},
});
